Namespace 'ScheduledReportResults'

class ScheduledReportResults.ScheduledReportResultsView extends Backbone.View
  template: JST['backbone/templates/scheduled_report_results']

  initialize: (results) ->
    @results = results

  render: ->
    @$el.html @template({
      count: @results.models.length,
      createdAt: @_getTranslation('created_at'),
      updatedAt: @_getTranslation('updated_at'),
      description: @_getTranslation('report_description'),
      status: @_getTranslation('status'),
      configuration: @_getTranslation('serialized_report_configuration'),
      resultFileUrl: @_getTranslation('result_file_url'),
      errorMessage: @_getTranslation('error_message')
    })
    for result in @results.models
      resultView = new ScheduledReportResults.ScheduledReportResultView(result)
      @$el.find('#results-table-body').append(resultView.render().$el)
    @

  _getTranslation: (field) ->
    I18n.t("customer.reports.results.#{field}")
